/* Diente — hero slider: cross-fade autoplay, pauses on hover/focus. */
(function () {
  'use strict';

  if (customElements.get('hero-slider')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-slide-dot]'));
      this.index = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.dots.forEach(
        function (dot) {
          dot.addEventListener('click', function () {
            this.goTo(Number(dot.getAttribute('data-slide-dot')));
            this.restart();
          }.bind(this));
        }.bind(this)
      );

      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      this.addEventListener('focusin', this.stop.bind(this));
      this.addEventListener('focusout', this.start.bind(this));

      // Don't burn cycles while the tab is hidden.
      document.addEventListener(
        'visibilitychange',
        function () {
          if (document.hidden) this.stop();
          else this.start();
        }.bind(this)
      );

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    goTo(index) {
      this.index = (index + this.slides.length) % this.slides.length;

      this.slides.forEach(
        function (slide, i) {
          slide.classList.toggle('is-active', i === this.index);
        }.bind(this)
      );

      this.dots.forEach(
        function (dot, i) {
          dot.classList.toggle('is-active', i === this.index);
          dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
        }.bind(this)
      );
    }

    start() {
      if (reduceMotion.matches || this.timer) return;
      var delay = Number(this.getAttribute('data-autoplay')) || 5000;
      this.timer = setInterval(
        function () {
          this.goTo(this.index + 1);
        }.bind(this),
        delay
      );
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
